import axios, { AxiosResponse } from 'axios'
import { FOUNDRY_URL } from 'constants/Api.constants'
import { convertResourceToEntity } from '@vendorflow/common/lib/converters/JsonApi.converter'
import { getRelationship } from 'services/Azimuth.service'
import { MultiResourceResponse, ResourceTypes, Tenant, TenantEndpointAddress } from '@vendorflow/types'
import {
  EndpointAddressWithRelationships,
  TenantWithPreferredEndpoints,
} from 'features/tenants-endpoints-addresses/TenantsEndpointsAddresses.types'
import { AUTHORIZATION_SENTINEL } from 'features/auth/Auth.constants'

const BASE_URL = `${FOUNDRY_URL}/v0/tenants`

export async function fetchTenantConfigUsingGET(tenant: string) {
  const response: AxiosResponse<MultiResourceResponse<Tenant, ResourceTypes.TENANTS>> = await axios.request({
    method: 'GET',
    url: `${BASE_URL}/${tenant}`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })
  // @ts-ignore
  const entity = convertResourceToEntity(response.data.data)
  const result: TenantWithPreferredEndpoints = {
    ...entity,
    relationships: {
      // @ts-ignore
      endpointPreference: getRelationship(response.data.data.relationships?.endpointPreference).get(),
    },
  }

  return result
}

export async function fetchEndpointAddressesUsingGET(tenant: string, endpoint: string) {
  const response: AxiosResponse<
    MultiResourceResponse<TenantEndpointAddress, ResourceTypes.TENANTS_ENDPOINTS_ADDRESSES>
  > = await axios.request({
    method: 'GET',
    url: `${BASE_URL}/${tenant}/endpoints/${endpoint}/addresses`,
    headers: { Authorization: AUTHORIZATION_SENTINEL },
  })

  const result: EndpointAddressWithRelationships[] = response.data.data.map((r) => {
    return {
      ...(convertResourceToEntity(r) as TenantEndpointAddress),
      relationships: {
        endpoint: getRelationship(r.relationships?.endpoint).getFirst()!,
        tenant: getRelationship(r.relationships?.tenant).getFirst()!,
        represents: getRelationship(r.relationships?.represents).get(),
      },
    }
  })

  return result
}
